import { useEffect, useRef, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

//Primereact components
import { Toast } from 'primereact/toast';
import { Badge } from 'primereact/badge';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { InputSwitch } from 'primereact/inputswitch';
import { FileUpload } from 'primereact/fileupload';
import { Dialog } from 'primereact/dialog';

//Services
import { getAllDetails, postAllData } from '../../../service/ProductService';

// Data table
import { defaultRowOptions, Skeletonitems, SkeletonbodyTemplate } from '../../../appconfig/Settings';

import AppBreadcrumb from '../../../components/CustomeBreadcrumb/AppBreadcrumb';

import { ELIGIBLEDOCUMENTLIST, GETELEGIBLEDATA, SAVEELIGIBLE, SAVEELIGIBLEOTHER, UPLOADELIGIBLEDOCUMENT, VERIFYELIGIBLEDOCUMET } from '../../../config/ApiConstant';
import { formatDateTime, setOtherAppStatus } from '../../../appconfig/AppHelper';
import { ViewDocumentColumns } from '../../../appconfig/DatatableSetting';
import ApprovalModal from '../../../components/Modal/ApprovalModal';
import Loader from '../../../components/Loadeer/Loader';

export const ViewEligibleDocument = () => {
    document.title = 'View Document | GSPC';

    // Parameters
    const { fileNo, appName, state }: any = useParams();

    const navigate = useNavigate();

    //Set Toast/ Filter Properties
    const toast = useRef<any>(null);

    // File Upload Details
    const fileUploadRef = useRef(null);

    //Loading/Page Loading
    const [loading, setLoading] = useState<boolean>(false);
    const [pageLoad, setPageLoad] = useState<boolean>(false);
    const [fileDetails, setFileDetails] = useState<any>([]);
    const [applicationStatus, setApplicationStatus] = useState<any>();
    const [documentsList, setDocumentsList] = useState<any>([]);
    const [submitLoading, setSubmitLoading] = useState<boolean>(false);
    const [changeStatusModal, setChangeStatusModal] = useState<boolean>(false);
    const [submitAppModal, setSubmitAppModal] = useState<boolean>(false);
    const [submitAppLoader, setSubmitAppLoader] = useState<boolean>(false);

    // useEffect
    useEffect(() => {
        getFileDetails();
        getAllDocument();
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }, []);

    // Get file details
    const getFileDetails = async () => {
        try {
            setLoading(true);
            const response = await getAllDetails(GETELEGIBLEDATA + '?fileNo=' + atob(fileNo) + '&AppName=' + atob(appName));
            if (response) {
                setFileDetails(response);
                // Application Status
                let applicationBadgeInfo = setOtherAppStatus(response.RegApproved);
                setApplicationStatus(applicationBadgeInfo);
                setLoading(false);
            }
        } catch (error: any) {
            setLoading(false);

            toast.current?.show({
                severity: 'error',
                summary: 'Error',
                detail: 'Sorry Could Not Load Data'
            });
        }
    };

    // Get all document
    const getAllDocument = async () => {
        try {
            setPageLoad(false);
            const response = await getAllDetails(ELIGIBLEDOCUMENTLIST + '?fileNo=' + atob(fileNo) + '&AppName=' + atob(appName));
            if (response) {
                setDocumentsList(response?.documents);
                setPageLoad(true);
            }
        } catch (error: any) {
            toast.current?.show({
                severity: 'error',
                summary: 'Error',
                detail: 'Sorry Could Not Load Data'
            });
        }
    };

    // On file upload
    const onFileUpload = async (e: any, rowData: any) => {
        let fileSize = e.files[0].size / 1024 / 1024;
        if (fileSize > 2) {
            toast.current?.show({
                severity: 'error',
                summary: 'Error',
                detail: 'Please upload file size less than 2mb'
            });
        } else {
            try {
                setSubmitLoading(true);

                //Request object
                let formData: any = new FormData();
                formData.append('file', e.files[0]);
                formData.append('document_id', rowData.docId);
                formData.append('fileNo', atob(fileNo));
                formData.append('parent_id', atob(fileNo));
                formData.append('applicationTypeName', atob(appName));

                //apicall
                const response = await postAllData(UPLOADELIGIBLEDOCUMENT, formData);
                if (response && !window.cn(response)) {
                    setSubmitLoading(false);
                    toast.current?.show({ severity: 'success', summary: 'Success', detail: response?.message });
                    setTimeout(() => {
                        getAllDocument();
                    }, 1500);
                }
            } catch (error: any) {
                toast.current?.show({
                    severity: 'error',
                    summary: 'Error',
                    detail: 'Could not upload file'
                });
            }
        }
    };

    // On verify document
    const onVerifyDocument = async (verified: any, userDocId: any) => {
        let isVerified = verified === true ? 1 : 0;
        setSubmitLoading(true);
        const response = await getAllDetails(VERIFYELIGIBLEDOCUMET + '?fileNo=' + atob(fileNo) + '&userDocId=' + userDocId + '&isVerified=' + isVerified);
        if (response) {
            setSubmitLoading(false);
            toast.current?.show({ severity: 'success', summary: 'Success', detail: 'Document Status Changed' });
            setTimeout(() => {
                getAllDocument();
            }, 1500);
        }
    };

    // Template for view
    const viewTemplate = (rowData: any) => {
        return (
            <>
                <Button icon="pi pi-eye" onClick={() => window.open(rowData?.image_url)} disabled={!window.cn(rowData?.image_url) ? false : true} />
            </>
        );
    };

    // Template for upload
    const uploadTemplate = (rowData: any) => {
        return (
            <>
                <FileUpload ref={fileUploadRef} accept="application/pdf" name="file[]" mode="basic" onSelect={(e) => onFileUpload(e, rowData)}></FileUpload>
            </>
        );
    };

    // Template for document name
    const docNameTemplate = (rowData: any) => {
        return (
            <>
                <Button tooltip={rowData?.DocName} className="p-button-custom-tooltip" tooltipOptions={{ position: 'top' }}>
                    <div className="college-name-div">
                        {' '}
                        {rowData?.DocName} {rowData?.is_required === true && <span style={{ color: 'red' }}>*</span>}
                    </div>
                </Button>
            </>
        );
    };

    // Template for verification
    const verificationTemplate = (rowData: any, rowIndex: any) => {
        return (
            <>
                <InputSwitch checked={rowData?.isVerified == '1' ? true : false} onChange={(e) => onVerifyDocument(e.value, rowData?.userDocId)} disabled={!window.cn(rowData?.image_url) && applicationStatus?.value !== 'Approved' ? false : true} />
            </>
        );
    };

    // Open change status modal
    const openChangeStatusModal = () => {
        setChangeStatusModal(true);
    };

    // Close change status modal
    const closeChangeStatusModal = () => {
        setChangeStatusModal(false);
    };

    // Open submit app modal
    const openSubmitAppModal = () => {
        setSubmitAppModal(true);
    };

    // Close submit app modal
    const closeSubmitAppModal = () => {
        setSubmitAppLoader(false);
        setSubmitAppModal(false);
    };


    // On submit application
    const onSubmitApplication = async () => {
        try {
            setSubmitAppLoader(true);
            let response: any;
            if (atob(state) === 'Maharshtra') {
                response = await getAllDetails(SAVEELIGIBLE + '?SrNo=' + fileDetails?.SrNo + '&RegApproved=1&practicalTraining=other&verified_by=' + localStorage.getItem('name'));
            } else {
                response = await getAllDetails(SAVEELIGIBLEOTHER + '?SrNo=' + fileDetails?.SrNo + '&RegApproved=1&verified_by=' + localStorage.getItem('name'));
            }
            if (response) {
                setSubmitAppLoader(false);
                setSubmitAppModal(false);
                toast.current?.show({
                    severity: 'success',
                    summary: 'Message',
                    detail: response
                });
                if (atob(state) === 'Maharshtra' && atob(appName) === 'Eligibility Certificate') {
                    navigate('/app/application/eliglible-application-list');
                }
                if (atob(state) === 'Other' && atob(appName) === 'Eligibility Certificate') {
                    navigate('/app/application/eliglible-application-other-list');
                }
            }
        } catch (error: any) {
            toast.current?.show({
                severity: 'error',
                summary: 'Error',
                detail: 'Sorry Could Not Load Data'
            });
        }
    };

    return (
        <>
            <Toast ref={toast} />
            <AppBreadcrumb currentMenu={'Applications'} pageName={'View Document'} pageTitle={'View Document'} goToPage={true} />
            <div className="card">
                <div className="grid">
                    <div className="field col-12 md:col-6  grid flex-column mb-0">
                        <div className="field col-12 grid mb-3">
                            <div className="field col-12 md:col-2 mb-0">
                                <b>Full Name</b>
                            </div>
                            <div className="field col-12 md:col-1 mb-0">:</div>
                            <div className="field col-12 md:col-7 mb-0">
                                {!window.cn(fileDetails?.StudL) && fileDetails?.StudL} {!window.cn(fileDetails?.StudF) && fileDetails?.StudF} {!window.cn(fileDetails?.StudM) && fileDetails?.StudM}
                            </div>
                        </div>

                        <div className="field col-12 grid mb-3">
                            <div className="field col-12 md:col-2 mb-0">
                                <b>File No</b>
                            </div>
                            <div className="field col-12 md:col-1 mb-0">:</div>
                            <div className="field col-12 md:col-7 mb-0">{fileDetails?.SrNo}</div>
                        </div>

                        <div className="field col-12 grid mb-3">
                            <div className="field col-12 md:col-2 mb-0">
                                <b>Status</b>
                            </div>
                            <div className="field col-12 md:col-1 mb-0">:</div>
                            <div className="field col-12 md:col-7 mb-0">{!window.cn(applicationStatus?.severity) && <Badge severity={applicationStatus?.severity} value={applicationStatus?.value}></Badge>}</div>
                        </div>
                        {applicationStatus?.appStatus === 'Hold' && (
                            <div className="field col-12 grid mb-0">
                                <div className="field col-12 md:col-2 mb-0">
                                    <b>Reason</b>
                                </div>
                                <div className="field col-12 md:col-1 mb-0">:</div>
                                <div className="field col-12 md:col-9 mb-0">{!window.cn(fileDetails?.comment) ? fileDetails?.comment : '-'}</div>
                            </div>
                        )}
                    </div>

                    <div className="field col-12 md:col-6 grid flex-column align-items-end mb-0">
                        <div className="field col-12 grid mb-3 justify-content-end">
                            <div className="field col-12 md:col-3 mb-0">
                                <b>Application Date</b>
                            </div>
                            <div className="field col-12 md:col-1 mb-0">:</div>
                            <div className="field col-12 md:col-2 mb-0">{formatDateTime(fileDetails?.EntDt)}</div>
                        </div>

                        {!window.cn(fileDetails?.RegNo) && (
                            <div className="field col-12 grid mb-3 justify-content-end">
                                <div className="field col-12 md:col-3 mb-0">
                                    <b>Reg No</b>
                                </div>
                                <div className="field col-12 md:col-1 mb-0">:</div>
                                <div className="field col-12 md:col-2 mb-0">{fileDetails?.RegNo}</div>
                            </div>
                        )}

                        <div className="field col-12 grid mb-3 justify-content-end mb-0">
                            <div className="field col-12 md:col-3 mb-0">
                                <b>Mobile No</b>
                            </div>
                            <div className="field col-12 md:col-1 mb-0">:</div>
                            <div className="field col-12 md:col-2 mb-0">{fileDetails?.PPhone}</div>
                        </div>

                        <div className="field col-12 grid justify-content-end">
                            <div className="field col-12 md:col-3 mb-0">
                                <b>DOB</b>
                            </div>
                            <div className="field col-12 md:col-1 mb-0">:</div>
                            <div className="field col-12 md:col-2 mb-0"> {formatDateTime(fileDetails?.BOD)}</div>
                        </div>
                    </div>
                </div>

                {/* Datatable */}
                {pageLoad ? (
                    <>
                        <DataTable value={documentsList} loading={submitLoading} showGridlines stripedRows rows={defaultRowOptions} className="datatable-responsive mt-3" emptyMessage="No Documents Found">
                            {ViewDocumentColumns.map((col, i) => {
                                if (col.field === 'view') {
                                    return <Column key={col.field} field={col.field} header={col.header} body={viewTemplate} />;
                                } else if (col.field === 'doc_name') {
                                    return <Column key={col.field} field={col.field} header={col.header} body={docNameTemplate} style={{ maxWidth: '16rem' }} />;
                                } else if (col.field === 'upload') {
                                    return <Column key={col.field} field={col.field} header={col.header} body={uploadTemplate} />;
                                } else if (col.field === 'verification') {
                                    return <Column key={col.field} field={col.field} header={col.header} body={verificationTemplate} />;
                                } else if (col.field === 'sr_no') {
                                    return <Column key={col.field} header={col.header} body={(_, { rowIndex }) => rowIndex + 1} style={{ maxWidth: '2rem' }} />;
                                } else {
                                    return <Column key={col.field} field={col.field} header={col.header} sortable filter filterPlaceholder={'Search by ' + col.header} />;
                                }
                            })}
                        </DataTable>
                    </>
                ) : (
                    <>
                        {/* Skeleton Data table */}
                        <DataTable value={Skeletonitems} className="mt-3">
                            {ViewDocumentColumns.map((col, i) => (
                                <Column key={col.field} field={col.field} header={col.header} body={SkeletonbodyTemplate} />
                            ))}
                        </DataTable>
                    </>
                )}

                <div className="formgrid grid mt-3">
                    <div className="field col-12 md:col-12">
                        <div style={{ display: 'flex', float: 'right', gap: 4 }}>
                            <Button className="p-button-secondary mr-2" icon="fas fa-edit" label="Change Status" onClick={openChangeStatusModal} disabled={applicationStatus?.value === 'Approved' ? true : false} />
                            <Button label="Submit" icon="pi pi-check" onClick={() => openSubmitAppModal()} loading={false} disabled={applicationStatus?.value === 'Approved' ? true : false} />
                        </div>
                    </div>
                </div>
            </div>

            {/* Change Status Modal */}
            <ApprovalModal id={fileDetails?.SrNo} appName={atob(appName)} visible={changeStatusModal} close={() => closeChangeStatusModal()} applicationName={atob(appName)} docList={documentsList} />

            {/* Submit Application Dialog */}
            <Dialog
                visible={submitAppModal}
                className="p-fluid"
                style={{ width: '100vh' }}
                header={'Approve Application'}
                modal
                draggable={false}
                resizable={false}
                footer={
                    <>
                        <Button label="Cancel" icon="pi pi-times" className="p-button-secondary" onClick={closeSubmitAppModal} />
                        <Button label="Submit" icon="pi pi-check" className="p-button-primary" onClick={() => onSubmitApplication()} loading={submitAppLoader} />
                    </>
                }
                onHide={closeSubmitAppModal}
            >
                <h5>Are you sure you want to submit this Application?</h5>
            </Dialog>


            {loading && <Loader />}
        </>
    );
};
